// firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyC_XTUaebMmiL9_Go1mu_MqYANwe57fUvU",
    authDomain: "anahex.com",
    projectId: "anahex-prod-e748e",
    storageBucket: "anahex-prod-e748e.firebasestorage.app",
    messagingSenderId: "138229769589",
    appId: "1:138229769589:web:a52a470a46645b3a0cdf3c",
    measurementId: "G-29ZWKRK4FV"
};

const app = initializeApp(firebaseConfig);

export const FirebaseAuthApp = getAuth(app);
export const GoogleFirebaseAuthProvider = new GoogleAuthProvider();
const analytics = getAnalytics(app);